import { useState, useEffect, useContext, useMemo } from "react";
import styles from './index.module.scss'
import Iconfont from '@utils/Iconfont';
import { message } from 'antd';
import { IMAGE_TYPE, RESOURCE_TYPE, CLOTH_COLOR_TYPE } from '@utils/CONST'
import { workflowOfSendTask, workflowOfLoadTaskInfo, workflowOfReGenerate } from '@utils/workflowOfBuildTaskV2';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '@utils/AppContext';
import API from '@api/api'

const PicModalRightButton = (props) => {
    const { item, fetchProjectDetail } = props
    const { setGlobalTaskReadFlag } = useContext(AppContext)
    const navigate = useNavigate()
    const [imageUrl, setImageUrl] = useState()

    useEffect(() => {
        const fetchImageUrl = async () => {
            try {
                let res = await API.commonDownload({ taskId: item.taskId });
                if (res?.code != 0) throw new Error(res?.message);
                const image = res.data;
                setImageUrl(image)
            } catch (error) {
                console.error('Failed to fetch image:', error);
            }
        }
        if (item) {
            fetchImageUrl();
        }
    }, [item])

    const handleClick = async (jumpTotype, targetType = "inputImage") => {
        let noWaterRes = await API.commonDownload({ taskId: item?.taskId })
        if (noWaterRes?.code != 0) throw new Error(noWaterRes?.message)
        const image = noWaterRes.data
        const res = await workflowOfSendTask(jumpTotype, image, targetType)
        if (!res) return
        const { pathname, options } = res
        navigate(pathname, options)
    }

    const rebuildClick = async (commidityOldDataRebuild) => {
        const succeededItem = item
        if (succeededItem) {
            try {
                const res = await workflowOfLoadTaskInfo(succeededItem.imageType, succeededItem.taskId, commidityOldDataRebuild)
                if (!res) return
                const { pathname, options } = res
                navigate(pathname, options)
            } catch (err) {
                message.warning(err.message)
            }
        } else {
            message.warning('请先等待生成成功后再重新编辑')
        }
    }

    const createAgain = async () => {
        const succeededItem = item
        if (succeededItem) {
            try {
                const taskID = succeededItem.taskId
                const res = await workflowOfReGenerate(succeededItem.imageType, taskID)
                if (!res) return
                const { disabled, pathname, options } = res
                if (disabled) {
                    message.warning("版本更新，请重新编辑后再重新生成")
                    navigate(pathname, options)
                } else {
                    message.success('生成中，请稍后！')
                    setGlobalTaskReadFlag(prev => !prev)
                    if (fetchProjectDetail) fetchProjectDetail()
                }
            } catch (err) {
                message.warning(err.message)
            }
        } else {
            message.warning('请先等待生成成功后再重新生成')
        }
    }

    const extractionClick = () => {
        window.open(imageUrl ? `/home/image_extraction?url=${encodeURIComponent(imageUrl)}` : `/home/image_extraction`, '_blank')
    }

    const resizeClick = () => {
        window.open(imageUrl ? `/home/imageResize?url=${encodeURIComponent(imageUrl)}` : `/home/imageResize`, '_blank')
    }

    const IsEiEdit = useMemo(() => {
        if (!item) return false
        return item.imageType == IMAGE_TYPE.AI_IMAGE_EXTRACTION ||
            item.imageType == IMAGE_TYPE.REMOVE_INPAINT ||
            item.imageType == IMAGE_TYPE.AI_BEAUTY ||
            item.imageType == IMAGE_TYPE.AI_SMART_BEAUTY ||
            item.imageType == IMAGE_TYPE.IMAGE_RESIZE ||
            item.imageType == IMAGE_TYPE.HAND_FIX
    }, [item])

    if (!item || IsEiEdit || item?.orgData) return null;

    const isVideoType = item.imageType === IMAGE_TYPE.MODEL_VIDEO || item.imageType === IMAGE_TYPE.IMAGE_TO_VIDEO;

    // Helper boolean for the large group of types that share similar buttons
    const isModelGroup = (
        item.imageType === IMAGE_TYPE.MODEL ||
        item.imageType === IMAGE_TYPE.BACKGROUND ||
        item.imageType === IMAGE_TYPE.FUSION_WEAR ||
        item.imageType === IMAGE_TYPE.GRASS_PLANT ||
        (item.imageType === IMAGE_TYPE.CLOTH_RECOLOR && item.mode === CLOTH_COLOR_TYPE.SIM_RECOLOR) ||
        (item.imageType === IMAGE_TYPE.CLOTH_RECOLOR && item.mode === CLOTH_COLOR_TYPE.CLOTH_RECOLOR && item.clothReColorIsPerson)
    );

    const modifyImageGroup = [];
    const generateVideoGroup = [];
    const aiEditGroup = [];
    const reOperateGroup = [];

    // --- Modify Image Group ---

    // Change Model
    const showChangeModel =
        (item.imageType === IMAGE_TYPE.CLOTHES) ||
        (item.imageType === IMAGE_TYPE.POSE_TRYON) ||
        (item.imageType === IMAGE_TYPE.GLASSES_TRYON) ||
        (item.imageType === IMAGE_TYPE.SIM_TRYON) ||
        (item.imageType === IMAGE_TYPE.SHOES) ||
        (item.imageType === IMAGE_TYPE.CLOTH_RECOLOR && item.clothReColorIsPerson) ||
        ((item.imageType === IMAGE_TYPE.FUSION_WEAR || item.imageType === IMAGE_TYPE.GRASS_PLANT || item.imageType === IMAGE_TYPE.BACKGROUND) && !isVideoType);

    if (showChangeModel) {
        modifyImageGroup.push({ label: '换模特', icon: 'icon-aiModelOutlined', onClick: () => handleClick(IMAGE_TYPE.MODEL) });
    }

    // Change Background
    const showChangeBackground =
        (item.imageType === IMAGE_TYPE.CLOTHES) ||
        (item.imageType === IMAGE_TYPE.POSE_TRYON) ||
        (item.imageType === IMAGE_TYPE.GLASSES_TRYON) ||
        (item.imageType === IMAGE_TYPE.SIM_TRYON) ||
        (item.imageType === IMAGE_TYPE.SHOES) ||
        (item.imageType === IMAGE_TYPE.CLOTH_RECOLOR && item.clothReColorIsPerson) ||
        ((item.imageType === IMAGE_TYPE.FUSION_WEAR || item.imageType === IMAGE_TYPE.GRASS_PLANT) && !isVideoType);

    if (showChangeBackground) {
        modifyImageGroup.push({ label: '换背景', icon: 'icon-aiModelOutlined', onClick: () => handleClick(IMAGE_TYPE.BACKGROUND) });
    }

    // Change Pose
    const showChangePose =
        (item.imageType === IMAGE_TYPE.CLOTHES) ||
        isModelGroup ||
        (item.imageType === IMAGE_TYPE.SHOES) ||
        (item.imageType === IMAGE_TYPE.GLASSES_TRYON) ||
        (item.imageType === IMAGE_TYPE.SIM_TRYON);

    if (showChangePose) {
        modifyImageGroup.push({ label: '换姿势', icon: 'icon-poseFantasyOutlined', onClick: () => handleClick(IMAGE_TYPE.POSE_TRYON) });
    }

    // Change Clothes
    const showChangeClothes =
        isModelGroup ||
        (item.imageType === IMAGE_TYPE.SHOES) ||
        (item.imageType === IMAGE_TYPE.POSE_TRYON) ||
        (item.imageType === IMAGE_TYPE.GLASSES_TRYON) ||
        (item.imageType === IMAGE_TYPE.SIM_TRYON);

    if (showChangeClothes) {
        modifyImageGroup.push({ label: '换衣服', icon: 'icon-aiModelOutlined', onClick: () => handleClick(IMAGE_TYPE.CLOTHES, RESOURCE_TYPE.TRYON_MODEL) });
    }

    // Change Shoes
    const showChangeShoes =
        (item.imageType === IMAGE_TYPE.CLOTHES) ||
        isModelGroup ||
        (item.imageType === IMAGE_TYPE.POSE_TRYON) ||
        (item.imageType === IMAGE_TYPE.GLASSES_TRYON) ||
        (item.imageType === IMAGE_TYPE.SIM_TRYON);

    if (showChangeShoes) {
        modifyImageGroup.push({ label: '换鞋子', icon: 'icon-shoesOutlined', onClick: () => handleClick(IMAGE_TYPE.SHOES, RESOURCE_TYPE.TRYON_SHOES) });
    }

    // Change Glasses
    const showChangeGlasses =
        (item.imageType === IMAGE_TYPE.CLOTHES) ||
        isModelGroup ||
        (item.imageType === IMAGE_TYPE.SHOES) ||
        (item.imageType === IMAGE_TYPE.POSE_TRYON) ||
        (item.imageType === IMAGE_TYPE.SIM_TRYON);

    if (showChangeGlasses) {
        modifyImageGroup.push({ label: '换眼镜', icon: 'icon-glassesOutlined', onClick: () => handleClick(IMAGE_TYPE.GLASSES_TRYON, RESOURCE_TYPE.GLASSES_TRYON) });
    }

    // Change Outfit (Fusion Wear)
    const showChangeOutfit =
        !isVideoType &&
        (item.imageType != IMAGE_TYPE.COMMODITY &&
            item.imageType != IMAGE_TYPE.FUSION_WEAR &&
            item.imageType != IMAGE_TYPE.COMMODITYRECOLOR &&
            item.imageType != IMAGE_TYPE.WATERMARK_REMOVE &&
            (item.imageType != IMAGE_TYPE.CLOTH_RECOLOR || item?.clothReColorIsPerson));

    if (showChangeOutfit) {
        modifyImageGroup.push({ label: '换穿搭', icon: 'icon-outfitSmallOutlined', onClick: () => handleClick(IMAGE_TYPE.FUSION_WEAR, RESOURCE_TYPE.FUSIONWEAR_MODEL) });
    }

    // Go to Grass
    const showGoToGrass =
        !isVideoType &&
        (item.imageType != IMAGE_TYPE.COMMODITY &&
            item.imageType != IMAGE_TYPE.GRASS_PLANT &&
            item.imageType != IMAGE_TYPE.COMMODITYRECOLOR &&
            item.imageType != IMAGE_TYPE.WATERMARK_REMOVE &&
            (item.imageType != IMAGE_TYPE.CLOTH_RECOLOR || item?.clothReColorIsPerson));

    if (showGoToGrass) {
        modifyImageGroup.push({ label: '去种草', icon: 'icon-sProductshowcaseOutlined', onClick: () => handleClick(IMAGE_TYPE.GRASS_PLANT) });
    }

    // Cloth Recolor
    if (!isVideoType && item.imageType != IMAGE_TYPE.CLOTH_RECOLOR) {
        modifyImageGroup.push({ label: '服饰换色', icon: 'icon-recolorOutlined', onClick: () => handleClick(IMAGE_TYPE.CLOTH_RECOLOR) });
    }

    // Sim Tryon
    const showSimTryon =
        (item.imageType === IMAGE_TYPE.CLOTHES) ||
        isModelGroup ||
        (item.imageType === IMAGE_TYPE.SHOES) ||
        (item.imageType === IMAGE_TYPE.POSE_TRYON) ||
        (item.imageType === IMAGE_TYPE.GLASSES_TRYON);

    if (showSimTryon) {
        modifyImageGroup.push({ label: '同版型试衣', icon: 'icon-sametryOutlined', onClick: () => handleClick(IMAGE_TYPE.SIM_TRYON, RESOURCE_TYPE.SIM_TRYON) });
    }

    // Commodity Change Back
    const showCommodityChangeBack =
        (item.imageType === IMAGE_TYPE.COMMODITYRECOLOR || (item.imageType === IMAGE_TYPE.CLOTH_RECOLOR && item.mode === CLOTH_COLOR_TYPE.CLOTH_RECOLOR && !item.clothReColorIsPerson)) ||
        (item.imageType === IMAGE_TYPE.WATERMARK_REMOVE);

    if (showCommodityChangeBack) {
        modifyImageGroup.push({ label: '商品换背', icon: 'icon-commidityOutlined', onClick: () => handleClick(IMAGE_TYPE.COMMODITY) });
    }

    // Commodity Recolor
    const showCommodityRecolorSpecific =
        (item.imageType === IMAGE_TYPE.CLOTHES) ||
        isModelGroup ||
        (item.imageType === IMAGE_TYPE.SHOES) ||
        (item.imageType === IMAGE_TYPE.COMMODITY) ||
        (item.imageType === IMAGE_TYPE.WATERMARK_REMOVE) ||
        (item.imageType === IMAGE_TYPE.POSE_TRYON) ||
        (item.imageType === IMAGE_TYPE.GLASSES_TRYON) ||
        (item.imageType === IMAGE_TYPE.SIM_TRYON);

    if (showCommodityRecolorSpecific) {
        modifyImageGroup.push({ label: '商品换色', icon: 'icon-recolorOutlined', onClick: () => handleClick(IMAGE_TYPE.COMMODITYRECOLOR) });
    }


    // --- Generate Video Group ---

    // Image to Video
    if (!isVideoType) {
        generateVideoGroup.push({ label: '图生视频', icon: 'icon-tryonVideoOutlined', onClick: () => handleClick(IMAGE_TYPE.IMAGE_TO_VIDEO) });
    }

    // Motion Mimic
    const showMotionMimic =
        (item.imageType === IMAGE_TYPE.CLOTHES) ||
        isModelGroup ||
        (item.imageType === IMAGE_TYPE.SHOES) ||
        (item.imageType === IMAGE_TYPE.POSE_TRYON) ||
        (item.imageType === IMAGE_TYPE.GLASSES_TRYON) ||
        (item.imageType === IMAGE_TYPE.SIM_TRYON);

    if (showMotionMimic) {
        generateVideoGroup.push({ label: '动作模仿', icon: 'icon-tryonVideoOutlined', onClick: () => handleClick(IMAGE_TYPE.MODEL_VIDEO) });
    }

    // --- AI Edit Group ---

    // Matting (Extraction)
    if (!isVideoType) {
        aiEditGroup.push({ label: '抠图', icon: 'icon-mattingOutlined', onClick: extractionClick });
    }

    // Resize
    if (!isVideoType) {
        aiEditGroup.push({ label: '改尺寸', icon: 'icon-picResizeOutlined', onClick: resizeClick });
    }

    if (!isVideoType) {
        aiEditGroup.push({ label: '修光影', icon: 'icon-lightIconOutlined', onClick: () => navigate("/home/aiEdit", { state: { menuKey: 'filllight', picUrl: imageUrl } }) });
    }

    // Hand Repair
    const showHandRepair = !isVideoType && (item.imageType != IMAGE_TYPE.COMMODITY && item.imageType != IMAGE_TYPE.COMMODITYRECOLOR && item.imageType != IMAGE_TYPE.CLOTH_RECOLOR);
    if (showHandRepair) {
        aiEditGroup.push({ label: '修手', icon: 'icon-handRepairOutlined', onClick: () => navigate("/home/aiEdit", { state: { menuKey: 'handRepair', picUrl: imageUrl } }) });
    }

    // Magic Erase
    if (!isVideoType) {
        aiEditGroup.push({ label: '去杂物', icon: 'icon-magicRemoveOutlined', onClick: () => navigate("/home/aiEdit", { state: { menuKey: 'magicErase', picUrl: imageUrl } }) });
    }

    // Watermark Remove
    if (!isVideoType && item.imageType != IMAGE_TYPE.WATERMARK_REMOVE) {
        aiEditGroup.push({ label: '去水印', icon: 'icon-removeWatermark', onClick: () => handleClick(IMAGE_TYPE.WATERMARK_REMOVE) });
    }

    // --- Re-operate Group ---

    // Re-edit
    reOperateGroup.push({ label: '重新编辑', icon: 'icon-rebuildOutlined', onClick: () => rebuildClick() });

    // Regenerate
    reOperateGroup.push({
        label: '再次生成', icon: 'icon-generateOutlined', onClick: () => {
            if (item.imageType === IMAGE_TYPE.COMMODITY && item.version !== 'V3.8.20251127') {
                rebuildClick(true)
            } else createAgain()
        }
    });

    return (
        <div className={`${styles.PicModalRightButton} _beauty_scrollbar`}>
            {modifyImageGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>修改图片</div>
                    {modifyImageGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}

            {generateVideoGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>生成视频</div>
                    {generateVideoGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}

            {aiEditGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>AI 编辑</div>
                    {aiEditGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}

            {reOperateGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>再次操作</div>
                    {reOperateGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default PicModalRightButton